import $ from 'cash-dom';
import Cookies from 'js-cookie';
export default function () {
  const homepageCalloutHidden = Cookies.get('homepageCalloutHidden');
  function removeCallout() {
    $('#callout').remove();
  }
  if (homepageCalloutHidden === 'true') {
    removeCallout();
  } else {
    $('#callout').removeClass('hidden');
  }
  $('.js-cts--close').on('click', e => {
    e.preventDefault();
    removeCallout();
    Cookies.set('homepageCalloutHidden', 'true', {
      expires: 30
    });
  });
}